<template>
    <div @click="showMenu = 1">
        <v-list>
            <v-list-group v-for="(header, idx) in documents.subcategory" :key="idx" :value="false"
                prepend-icon="mdi-file">
                <template v-slot:activator>
                    <v-list-item-title>{{ header.SubCategory }}</v-list-item-title>
                </template>
                <v-list-item v-for="(item, idxItm) in header.docs" :key="idxItm + header.SubCategory"
                    @click="openFile(item)" @contextmenu.prevent="$refs.menuGo.open($event, item)">
                    <v-list-item-avatar>
                        <v-img src="../../../assets/pdf-logo.png"></v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title v-text="item.Document"></v-list-item-title>
                        <span v-if="item.ExpTitle != undefined">Expire Date <strong>{{ item.ExpDate == NULL ? '' :
                            item.ExpDate
                                }}</strong></span>
                    </v-list-item-content>

                    <v-list-item-avatar>
                        <v-icon :color="item.Status == 1 ? 'success' : item.Status == 2 ? '#FFC107' : 'red'">
                            mdi-{{ item.Status == 1 ? 'check-circle' : item.Status == 0 ? 'alert-circle' : item.Status
                                == 2 ? 'cancel' :
                                'circle' }}
                        </v-icon>
                    </v-list-item-avatar>
                </v-list-item>
            </v-list-group>
        </v-list>
        <vue-context ref="menuGo" dense>
            <template slot-scope="selected" v-if="selected.data">
                <li style="padding-right: 30px;">
                    {{ selected.data.Document }}
                </li>
                <li @click="deleteFiles(selected.data, 1)" class="my-2" v-if="disabled"
                    style="list-style: none;text-decoration: none;list-style-type: none;">
                    <v-icon color="red">mdi-delete-circle</v-icon> Delete Files
                </li>
                <li @click="changeStatus(selected.data, 0)" class="my-2" v-if="disabled"
                    style="list-style: none;text-decoration: none;list-style-type: none;">
                    <v-icon color="red">mdi-circle</v-icon> Change to undelivered status 
                </li>

                <li @click="deleteFiles(selected.data, 0)" class="my-2 pr-5" v-if="disabled"
                    style="list-style: none;text-decoration: none;list-style-type: none;">
                    <v-icon color="red">mdi-cancel</v-icon> Delete file & send status does not apply
                </li>

                <li @click="changeStatus(selected.data,2)" class="my-2 pr-5" v-if="disabled"
                    style="list-style: none;text-decoration: none;list-style-type: none;">
                    <v-icon color="orange">mdi-cancel</v-icon> Send status does not apply
                </li>
                <!-- <li @click="openAddSft(selected.data)" class="my-2 pr-5"
                    style="list-style: none;text-decoration: none;list-style-type: none;">
                    <v-icon color="success">mdi-plus-circle</v-icon> Add Safety Meeting
                </li> -->
            </template>
        </vue-context>
        <v-dialog v-model="dialog" max-width="460">
            <v-card>
                <v-container grid-list-xs>
                    <v-row>
                        <v-col>
                            <v-file-input v-model="file" multiple dense hide-details label="Update File"
                                @change="UpdateFile()"></v-file-input>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dlgAddSft" max-width="460">
            <v-card>
                <v-container grid-list-xs>

                    <v-row>
                        <v-col>
                            <v-combobox v-model="sftMtn" :items="sft" label="Add Safety Meeting"
                                :item-text="'Text'" :item-value="'SftMeetingId'" auto-select-first
                                dense @change="AddSft">
                            </v-combobox>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>

        <confirm-dialogue ref="confirmDialogue" style="z-index: 100;"></confirm-dialogue>
        <docsView v-if="docView" :docView="docView" :keyUrl="url" @close="docView = false;"></docsView>
    </div>
</template>
<script>
import axios from "axios";
import docsView from './OpenFile.vue';
import VueContext from 'vue-context';
import ConfirmDialogue from './../../Modals/ConfirmDialogue.vue';
export default {
    props: ['documents','driver'],
    components: {
        docsView,
        VueContext,
        ConfirmDialogue
    },
    data: function () {
        return {
            docView: false,
            url: '',
            file: null,
            showMenu: 1,
            dialog: false,
            item: null,
            dlgAddSft:false,
            sft: [],
            sftMtn: null,
            disabled: false
        }
    },
    mounted() {
        if(this.$store.state.roles == 'CardingAgent' || this.$store.state.roles == 'Human Resources' || this.$store.state.roles == 'Administrator'){
            this.disabled =true;
        }
        console.log(this.documents);
        // this.sftMeeting();
    },
    methods: {
        openUpdateModal: function (itm) {
            this.item = itm;
            this.dialog = true;
        },
        async deleteFiles(itm, option) {
            this.showMenu = 0;
            this.$refs.menuGo.close();
            const ok = await this.$refs.confirmDialogue.show({
                title: 'Delete File ' + itm.Document,
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.delete(itm, option);
            }
            this.showMenu = 1;
        },
        async UpdateFile() {
            this.dialog = false;
            const ok = await this.$refs.confirmDialogue.show({
                title: 'Update File ' + this.item.Document,
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                await this.update(this.item);
                this.showMenu = 1;
            }
        },

        async changeStatus(itm,st) {
            this.dialog = false;
            const ok = await this.$refs.confirmDialogue.show({
                title: 'The status of the document will be changed: ' + itm.Document,
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                await this.sendStatus(itm,st);
                this.showMenu = 1;
            }
        },
        update: async function (itm) {
            var str = this.$store;
            this.showMenu = 0;
            console.log(itm);

            if (itm.Status == 0 || itm.Status == 2) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'This file does not currently exist'
                });
            } else {
                try {
                    const formData = new FormData();
                    formData.append('file', this.file);
                    console.log(formData);

                    const response = await axios.post('driver-list/update/file/' + itm.DocumentEmployeeId, formData, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    });

                    console.log(response.data);
                    this.file = null;
                    itm.Url = response.data.Url;
                } catch (error) {
                    logErr(error);
                }

            }
        },
        delete: function (itm, option) {
            var str = this.$store;
            console.log(itm);
            if (itm.Status == 0 || itm.Status == 2) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'This file does not currently exist'
                });
            } else {
                axios
                    .post('driver-list/delete/files/' + option, itm, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response.data);
                        if (!option) {
                            itm.Status = 2;
                        } else {
                            itm.Status = 0;
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(() => {
                        str.state.isLoading = false;
                    });
            }
        },
        sendStatus: function (itm, st) {
            var str = this.$store;
            var parms = {
                Status: st
            }
            if (itm.Status == 1) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'To change the status to not applicable, the document must have no files attached or not have this option.'
                });
            } else {

                str.state.isLoading = true;
                axios
                    .put('driver-list/' + itm.DocumentEmployeeId, parms, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response.data);
                            itm.Status = st;
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(() => {
                        str.state.isLoading = false;
                    });
            }
        },
        openFile: function (itm) {
            this.url = itm;
            this.docView = true;
        },
        async AddSft() {
            this.dlgAddSft = false;
            const ok = await this.$refs.confirmDialogue.show({
                title: 'This safety meeting will be added to this driver ' + this.sftMtn.Text,
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.addSafetyMetting();
            }
        },
        
        sftMeeting() {
            this.$store.state.isLoading = true;
            axios
                .get('safety-meeting', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.sft = response.data;
                    this.sft.forEach(x => {
                        x.Text = x.Name + ' - ' + x.PrincipalRegion;
                    })
                    this.$store.state.isLoading = false;
                })
                .catch(error => {
                    logErr(error);
                });
        },
        
        openAddSft: function (itm) {
            this.item = itm;
            this.dlgAddSft = true;
        },
        addSafetyMetting: function () {
            var parms = {
                SftMeeting: this.sftMtn.SftMeetingId,
                Document: 58,
                EmployeeType: 1,
                Status: 0,
                EmployeeId: this.driver.id
            }
            axios
                .post('driver-list', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    const resp = {
                        DocumentEmployeeId: response.data.DocumentEmployeeId,
                        EmployeeType: 'Driver',
                        Status:0,
                        DocCategory:17,
                        Document:this.sftMtn.Text
                    };
                    const idx = await this.documents.subcategory.findIndex(x => {
                      return  x.SubCategory == "Safety Meetings";
                    })
                    console.log(idx);
                    this.documents['subcategory'][idx]['docs'].push(resp);
                    console.log(this.documents['subcategory'][idx]);
                    this.sftMtn = null;
                    this.$store.state.isLoading = false;
                })
                .catch(error => {
                    logErr(error);
                });
        }
    }
}
</script>